import React, { useState, useRef } from "react";
import "./candidateRegister.css";
import logo from '../../../../assets/images/Logo.png';
import GoogleIcon from '../../../../assets/images/google 1.png';
import LinkedInIcon from '../../../../assets/images/Ic_Linkedin.png';
import CloseIcon from "../../../../assets/images/Ic_close.png";
import Success from '../../../../assets/images/im_Success.png';
import { CandidatePreLoginService } from "../../../../services/candidatePreLoginService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { Eye, EyeOff } from "lucide-react";
import profilebackButtonIcon from '../../../../assets/images/Ic_back.png';
const CandidateRegistration = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        primaryPhoneNumber: "",
        primaryEmailId: "",
    });

    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [showCreatePasswordPopup, setShowCreatePasswordPopup] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPasswordSuccessPopup, setShowPasswordSuccessPopup] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");


    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const otpInputs = useRef([]);


    const validate = (name, value) => {
        let error = "";
        if (name === "firstName" || name === "lastName") {
            if (!/^[A-Za-z ]+$/.test(value)) error = "Name should contain only letters and spaces";
        }
        if (name === "primaryPhoneNumber") {
            if (/^0/.test(value)) {
                error = "Mobile number should not start with 0";
            } else if (!/^\+?[0-9]{2}[0-9]{10}$/.test(value)) {
                error = "Enter a valid mobile number (+919876XXXXX0)";
            }
        }
        if (name === "primaryEmailId") {
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                error = "Enter a valid email address";
            }
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === "primaryPhoneNumber") {
            newValue = newValue.replace(/^0+/, '');
            if (!newValue.startsWith("+")) {
                newValue = "+91" + newValue;
            }
        }

        const fieldError = validate(name, newValue);

        setFormData({ ...formData, [name]: newValue });
        setErrors({ ...errors, [name]: fieldError });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};
        Object.keys(formData).forEach((key) => {
            newErrors[key] = validate(key, formData[key]);
        });

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error !== "")) {
            alert("Please fix form errors before submitting.");
            return;
        }

        const payload = {
            firstName: formData.firstName.trim(),
            lastName: formData.lastName.trim(),
            primaryPhoneNumber: formData.primaryPhoneNumber.trim(),
            primaryEmailId: formData.primaryEmailId.trim(),
        };

        try {
            const response = await CandidatePreLoginService.candidateRegistration(payload);
            setShowSuccessPopup(true);

            setFormData({
                firstName: "",
                lastName: "",
                primaryPhoneNumber: "",
                primaryEmailId: "",
            });
            setErrors({});
        } catch (error) {
            console.error("Registration API Error:", error);

            const fieldViolations = error?.response?.data?.fieldViolations;
            const message = error?.response?.data?.message || "";

            if (fieldViolations && typeof fieldViolations === "object") {
                const firstKey = Object.keys(fieldViolations)[0];
                const violationMsg = fieldViolations[firstKey];

                setApiError(violationMsg || "Invalid field input. Please correct it.");
            }
            else if (message.toLowerCase().includes("email")) {
                setApiError("Duplicate email ID found. Please use a different one.");
            }
            else if (message.toLowerCase().includes("phone") || message.toLowerCase().includes("mobile")) {
                setApiError("Duplicate mobile number found. Please give a valid one.");
            }
            else {
                setApiError(message || "Registration failed. Please try again.");
            }
        }

    };


    const handleOTPBackClick = () => {
        setShowOtpPopup(false);
    };

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        if (value.length === 1 && index < otpInputs.current.length - 1) {
            otpInputs.current[index + 1].focus();
        }
    };

    const handleVerifyClick = () => {
        setShowSuccessPopup(true);
        setShowOtpPopup(false);
    };


    const handleCloseSuccessPopup = () => {
        setShowSuccessPopup(false);
        // setShowCreatePasswordPopup(true);
    };


    const handleConfirmPassword = () => {
        if (password === confirmPassword && password !== "") {
            setShowCreatePasswordPopup(false);
            setShowPasswordSuccessPopup(true);
        } else {
            alert("Passwords do not match. Please try again.");
        }
    };

    const handleNavigation = (path, section) => {
        if (!sessionStorage.getItem("initialScrollPosition")) {
            sessionStorage.setItem("initialScrollPosition", window.scrollY);
        }
        sessionStorage.setItem("scrollPosition", window.scrollY);
        window.location.href = `${path}?section=${section}`;
    };

    return (
        <>
            <div className='fluid-container'>
                <nav className="navbar navbar-light candidate-navbar-container">
                    <div className="container-fluid">
                        <a className="navbar-brand candidate-register-logo ms-5">
                            <img src={logo} alt="Logo" />
                        </a>
                    </div>
                </nav>

                <div className="candidate-registration-container">
                    <div className="row min-vh-100">

                        {/* Left Section - Registration Form */}
                        <div className="col-md-6 col-sm-12 candidate-register-form-section">
                            <button style={{ border: 'none', background: 'none' }} className="candidate-back-link" onClick={() => window.history.back()}>
                                <img src={profilebackButtonIcon} />
                                {' '}Back
                            </button>
                            <div className="p-4">
                                <h2 className="candidate-register-heading mb-4">Register with us</h2>

                                {/* <div className="candidate-register-social-login">
                                    <button className="btn candidate-register-social-btn me-2">
                                        <img src={GoogleIcon} alt="Google" className="candidate-register-social-icon" />
                                        Google
                                    </button>
                                    <button className="btn candidate-register-social-btn">
                                        <img src={LinkedInIcon} alt="LinkedIn" className="candidate-register-social-icon" />
                                        LinkedIn
                                    </button>
                                </div> */}

                                {/* <div className="or-container">
                                    <hr className="or-line" />
                                    <p className="or-text">Or</p>
                                    <hr className="or-line" />
                                </div> */}

                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3 candidate-register-input-group">
                                            <label className="candidate-register-label">First Name*</label>
                                            <input
                                                type="text"
                                                className="candidate-register-input"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.firstName && <p className="error">{errors.firstName}</p>}

                                        </div>
                                        <div className="col-md-6 mb-3 candidate-register-input-group">
                                            <label className="candidate-register-label">Last Name*</label>
                                            <input
                                                type="text"
                                                className="candidate-register-input"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.lastName && <p className="error">{errors.lastName}</p>}

                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 mb-3 candidate-register-input-group">
                                            <label className="candidate-register-label">Mobile*</label>
                                            <input
                                                type="text"
                                                className="candidate-register-input"
                                                name="primaryPhoneNumber"
                                                value={formData.primaryPhoneNumber}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.primaryPhoneNumber && <p className="error">{errors.primaryPhoneNumber}</p>}
                                            {/* <p className="candidate-register-info">OTP will be sent to your mobile number.</p> */}
                                        </div>

                                        <div className="col-md-6 mb-3 candidate-register-input-group">
                                            <label className="candidate-register-label">Email ID*</label>
                                            <input
                                                type="email"
                                                className="candidate-register-input"
                                                name="primaryEmailId"
                                                value={formData.primaryEmailId}
                                                onChange={handleChange}
                                                required
                                            />
                                            {errors.primaryEmailId && <p className="error">{errors.primaryEmailId}</p>}
                                            <p className="candidate-register-info">This will be your login ID.</p>
                                        </div>
                                    </div>


                                    {/* <div className="mb-3 form-check candidate-register-checkbox">
                                        <input type="checkbox" className="form-check-input" id="whatsappUpdate" />
                                        <label className="form-check-label candidate-register-check-label" htmlFor="whatsappUpdate">
                                            Update via WhatsApp
                                        </label>
                                    </div> */}
                                    <p className="candidate-register-terms text-center">
                                        By continuing, you accept all our{' '}
                                        <a
                                            className="candidate-register-terms-link"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleNavigation("/policy", "terms");
                                            }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            Terms & Conditions
                                        </a>
                                    </p>


                                    <div className="candidate-register-btn-container">
                                        <button type="submit" className="btn candidate-register-btn-primary">
                                            Register
                                        </button>
                                    </div>

                                </form>

                                <p className="candidate-register-text text-center mt-3">
                                    Already a user? <a href="/login" className="candidate-register-link">Log In</a>
                                </p>

                            </div>
                        </div>

                        <div className="col-md-6 col-sm-12 candidate-register-info-section">
                            <h2>Getting started is easy</h2>
                            <p>Leaderly is crafted for visibility and success and building your profile with us is hassle-free:</p>
                            <ul className="list-unstyled">
                                <li>
                                    <span className="step-check-icon">
                                        <i className="fas fa-check"></i>
                                    </span>
                                    Step 1: One-click sign up via Google / LinkedIn
                                </li>
                                <li>
                                    <span className="step-check-icon">
                                        <i className="fas fa-check"></i>
                                    </span>
                                    Step 2: Get on a call with our team who will build your profile for you
                                </li>
                                <li>
                                    <span className="step-check-icon">
                                        <i className="fas fa-check"></i>
                                    </span>
                                    Step 3: Verify details and approve
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {showOtpPopup && (
                <>
                    <div className="otp-overlay" onClick={handleOTPBackClick}></div>
                    <div className="otp-popup-container">
                        <button className="back-button" onClick={handleOTPBackClick}>
                            <img src={CloseIcon} alt="Close" />
                        </button>
                        <h2 className="otp-form-head">Confirm Your Registration</h2>
                        <p className="otp-instruction">Verify Your Mobile Number</p>
                        <p className="otp-mobile">
                            Enter The 4-Digit OTP Sent to{' '}
                            <span className="registered-mobile-number">
                                +91 9XXXX XX231 <FontAwesomeIcon icon={faPen} className="edit-icon" />
                            </span>
                        </p>
                        <div className="otp-input-container">
                            {[...Array(4)].map((_, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    className="otp-input"
                                    ref={(el) => (otpInputs.current[index] = el)}
                                    onChange={(e) => handleInputChange(e, index)}
                                />
                            ))}
                        </div>
                        <button className="verify-button" onClick={handleVerifyClick}>Verify</button>
                    </div>
                </>
            )}

            {showSuccessPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <button className="register-popup-close" onClick={handleCloseSuccessPopup}>
                            <img src={CloseIcon} alt="Close" />
                        </button>
                        <img src={Success} alt="success logo" className="success-logo" />
                        <h3>Registration successful!</h3>
                        <p style={{ marginTop: '8px', fontSize: '16px' }}>
                            Thank you for registering. Our team will get in touch with you soon.
                        </p>
                    </div>
                </div>
            )}

            {showCreatePasswordPopup && (
                <div className="popup-overlay">
                    <div className="popup-content candidate-create-password-popup">
                        <h3 className="popup-title-candidate-create-password">Create Password</h3>

                        <label className="candidate-create-password-label">Password*</label>
                        <div className="candidate-create-password-field">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="candidate-create-password-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button type="button" className="eye-icon" onClick={togglePasswordVisibility}>
                                {showPassword ? <EyeOff /> : <Eye />}
                            </button>
                        </div>

                        <label className="candidate-create-password-label">Confirm Password*</label>
                        <div className="candidate-create-password-field">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="candidate-create-password-input"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                autoComplete="new-password"
                            />
                            <button type="button" className="eye-icon" onClick={toggleConfirmPasswordVisibility}>
                                {showConfirmPassword ? <EyeOff /> : <Eye />}
                            </button>
                        </div>

                        <button className="candidate-create-password-confirm-button" onClick={handleConfirmPassword}>Confirm</button>
                    </div>
                </div>
            )}

            {showPasswordSuccessPopup && (
                <div className="popup-overlay">
                    <div className="popup-content register-popup-content">
                        <button className="register-popup-close" onClick={() => setShowPasswordSuccessPopup(false)}>
                            <img src={CloseIcon} alt="Close" />
                        </button>
                        <img src={Success} alt="success logo" className="success-logo" />
                        <h3>Password Successfully Created!</h3>
                        <p className="register-popup-subtext">Use your password to login</p>
                        <button className="register-popup-login-button"
                        //  onClick={() => window.location.href = "/login"}
                        >
                            Login
                        </button>
                    </div>
                </div>
            )}


            {apiError && (
                <div className="candidate-reg-alert-overlay" onClick={() => setApiError("")}>
                    <div
                        className="candidate-reg-alert-popup"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="candidate-reg-alert-close-btn" onClick={() => setApiError("")}>
                            <img src={CloseIcon} alt="Close" />
                        </button>

                        <div className="candidate-reg-alert-content">
                            <h3 className="candidate-reg-alert-title">Registration Error</h3>
                            <p className="candidate-reg-alert-message">{apiError}</p>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default CandidateRegistration;
